import {
  SchoolConfig,
  convertToSchoolConfig,
  schoolConfigCollectionKey
} from "@/entities/school";
import firebase from "firebase/app";

export async function getSchoolConfig(
  schoolId: string
): Promise<SchoolConfig | null> {
  try {
    const snapshot = await firebase
      .firestore()
      .collection(schoolConfigCollectionKey)
      .doc(schoolId)
      .get();
    const data = snapshot.data();
    if (!snapshot.exists || !data) {
      return null;
    }

    return convertToSchoolConfig(data, snapshot.ref);
  } catch (e) {
    console.error(e);
    return null;
  }
}
